module.exports = "https://lts-static.prod-my.games/promo/lp1/img/apple.7e5772cc.svg";